// noinspection JSUnusedGlobalSymbols

import Helper from '../../../client/helper.js'
import Network from '../../../client/network.js'

export default class
{
	static bulk_set(form)
	{
		Helper.confirm(Helper.message('#message-apply_confirm'), () =>
		{
			for(const weekday of form['weekday[]'])
			{
				const pattern = $(`#pattern`).val()
				$(`#form input[name="weekday[]"][value="${weekday.value}"]`).prop('checked', weekday.checked)

				for(const part of ['start_hour', 'start_minute', 'end_hour', 'end_minute'])
				{
					if(weekday.checked)
					{
						$(`#form select[name="${part}_${weekday.value}"]`).val(form[part].value).trigger('change')
						$(`#form select[data-weekday="${weekday.value}"]`).val(pattern).trigger('change')
					}
				}

				if(weekday.checked) $(`#form input[name="pattern[]"][value="${weekday.value}"]`).prop('checked', true)
			}
		})
	}

	static set_base(portal, name, checkbox)
	{
		const merge = $(checkbox).parent().parent().find('._merge')

		if(!checkbox.checked) merge.css('visibility', 'visible')
		else merge.css('visibility', 'hidden')
	}

	static sync_portal()
	{
		Helper.confirm(Helper.message('#message-staff_download_confirm'), () =>
		{
			const data = new FormData()
			data.set('__action', 'sync')

			Network.post(location.pathname, data, undefined, false)
		})
	}

	static sync_pattern(button)
	{
		Helper.confirm(Helper.message('#message-pattern_download_confirm'), () =>
		{
			const loader = $(button).find('._loader')
			loader.addClass('css-loader')

			const data = new FormData()
			data.set('__action', 'sync_pattern')

			Network.post(
				`/shift_pattern/`,
				data,
				() =>
				{
					$.get('/shift/shift_pattern/', (data) =>
					{
						loader.removeClass('css-loader')

						const option = []
						for(const row of data) option.push({id: `${row.start}-${row.end}`, text: `${row.name}(${row.short_name})`})

						$('select._pattern').select2({data: option})
					})
				},
				false,
			)
		})
	}

	static base_shift_download(button, staff_id)
	{
		Helper.confirm(Helper.message('#message-base_shift_download_confirm'), () =>
		{
			const loader = $(button).find('._loader')
			loader.addClass('css-loader')

			const data = new FormData()

			data.set('__action', 'base_shift_download')
			data.set('staff', staff_id)

			Network.post(
				location.pathname,
				data,
				() => loader.removeClass('css-loader'),
				true,
			)
		})
	}

	static apply_pattern(form, time, prefix = '')
	{
		if(time === '') return
		const [start, end] = time.split('-')

		const [start_hour, start_minute] = start.split(':')
		const [end_hour, end_minute] = end.split(':')

		let select = $(form.querySelector(`select[name="start_hour${prefix}"]`))
		select.val(start_hour).trigger('change')

		select = $(form.querySelector(`select[name="start_minute${prefix}"]`))
		select.val(start_minute).trigger('change')

		select = $(form.querySelector(`select[name="end_hour${prefix}"]`))
		select.val(end_hour).trigger('change')

		select = $(form.querySelector(`select[name="end_minute${prefix}"]`))
		select.val(end_minute).trigger('change')
	}

	static sync_unsynched(staff_id)
	{
		Helper.confirm(Helper.message('#message-sync_unsynched_confirm'), () =>
		{
			const data = new FormData()

			data.set('__action', 'sync_unsynched')
			data.set('staff_id', staff_id)

			Network.post(location.pathname, data, undefined, false)
		})
	}

}
